module.exports = __webpack_public_path__ + "img/276.270baef2.jpg";